<template>
  <v-container class="pa-0">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="10" lg="9" xl="8">
        <v-card style="min-height:50vh" v-intersect="onIntersect">
          <video
            @click="playing ? pauseVideo() : playVideo()"
            v-if="value.url"
            style="width:100%;height:auto"
            :src="value.url"
            :poster="value.thumbnail"
            playsinline
            ref="preview-video"
            loop
            muted
            @play="playing=true"
            @pause="playing=false"
            @timeupdate="setProgress"
          ></video>
          <v-overlay v-else absolute>Video Unavailable</v-overlay>
          <v-overlay absolute v-if="playing==false">
            <v-btn color="primary" @click="playVideo">
              <v-icon>fa-play</v-icon>
            </v-btn>
          </v-overlay>
          <v-progress-linear color="blue" striped :height="7" absolute bottom :value="progress"></v-progress-linear>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PagePreviewsVideo",
  props: ["value"],
  data() {
    return {
      isIntersecting: false,
      timer: null,
      progress: 0,
      playing: false
    };
  },
  created() {
    // this.timer = setInterval(this.setProgress, 100);
  },
  beforeDestroy() {
    //clearInterval(this.timer);
  },
  watch: {
    isIntersecting: function() {
      if (this.isIntersecting) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    }
  },
  methods: {
    playVideo() {
      this.$refs["preview-video"].play();
    },
    pauseVideo() {
      this.$refs["preview-video"].pause();
    },
    setProgress() {
      if (this.isIntersecting) {
        this.progress =
          (this.$refs["preview-video"].currentTime /
            this.$refs["preview-video"].duration) *
          100;
      }
    },
    onIntersect(entries) {
      this.isIntersecting = entries[0].isIntersecting;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>